<div class="router-oulet-cont" [@routerTransition]>
    <div class="w-100">
        <app-title [title]="title" [icon]="icon"></app-title>
    </div>
    <div class="table-card">
        <div class="table-card-header mt-3">
            <div class="search-filter-wrapper">
                <div class="input-cont">
                    <i class="icon-btn fas fa-search" (click)="getDataPage(1)"></i>
                    <input type="text" class="input-txt" name="keyword" [placeholder]="'SearchWithThreeDot' | localize"
                        [(ngModel)]="keyword" (ngModelChange)="isKeywordClean(keyword)"
                        (keyup.enter)="getDataPage(1)" />
                </div>
                <div class="filter-flat" (click)="showFilters()">
                    <i class="material-icons-outlined">filter_list</i>
                    <span>{{ 'Filters' | localize }}</span>
                </div>
            </div>
            <div *ngIf="showingFilters" class="dynamic-filters-container general-info-cont form-grid">
                <div class="input-label-cont extra form-grid-item">
                    <div class="input-cont icon-addon">
                        <input type="text" class="input-txt truncate-multiselect" name="fromMonth" autocomplete="off"
                            bsDatepicker [minDate]="fromMonthMinDate" [maxDate]="fromMonthMaxDate"
                            [bsConfig]="{ dateInputFormat: 'MM/YYYY', minMode: 'month' }" [(ngModel)]="fromMonth"
                            [placeholder]="'DateFrom' | localize" [ngModelOptions]="{ standalone: true }"
                            (ngModelChange)="onFilterChange()" />
                        <i class="fa-regular fa-calendar calendar-icon"></i>
                    </div>
                </div>

                <div class="input-label-cont extra form-grid-item">
                    <div class="input-cont icon-addon">
                        <input type="text" class="input-txt truncate-multiselect" name="toMonth" autocomplete="off"
                            bsDatepicker [minDate]="toMonthMinDate" [maxDate]="toMonthMaxDate"
                            [bsConfig]="{ dateInputFormat: 'MM/YYYY', minMode: 'month' }" [(ngModel)]="toMonth"
                            [placeholder]="'DateTo' | localize" [ngModelOptions]="{ standalone: true }"
                            (ngModelChange)="onToMonthChange($event)" />
                        <i class="fa-regular fa-calendar calendar-icon"></i>
                    </div>
                </div>

                <div class="input-label-cont extra form-grid-item">
                    <div class="input-cont icon-addon">
                        <p-multiSelect class="input-txt truncate-multiselect" [options]="getEventTypeOptions()"
                            [(ngModel)]="selectedEventTypes" optionLabel="label" optionValue="value"
                            [placeholder]="'SelectTypes' | localize" [selectedItemsLabel]="l('SelectedItemsLabel')"
                            [filter]="true" (onChange)="onFilterChange()" [emptyMessage]="'NoResultsFound' | localize"
                            [emptyFilterMessage]="'NoResultsFound' | localize">
                        </p-multiSelect>
                    </div>
                </div>

                <div class="input-label-cont extra form-grid-item">
                    <div class="input-cont icon-addon">
                        <p-multiSelect class="input-txt truncate-multiselect" [options]="companyOptions"
                            [(ngModel)]="selectedCompanies" optionLabel="label" optionValue="value"
                            [placeholder]="'Societies' | localize" [selectedItemsLabel]="l('SelectedItemsLabel')"
                            [filter]="true" (onChange)="onFilterChange()" [emptyMessage]="'NoResultsFound' | localize"
                            [emptyFilterMessage]="'NoResultsFound' | localize">
                        </p-multiSelect>
                    </div>
                </div>

                <div class="input-label-cont extra form-grid-item">
                    <div class="input-cont icon-addon">
                        <p-multiSelect class="input-txt truncate-multiselect" [options]="naturalPersonOptions"
                            [(ngModel)]="selectedNaturalPersons" optionLabel="label" optionValue="value"
                            [placeholder]="'NaturalPersons' | localize" [selectedItemsLabel]="l('SelectedItemsLabel')"
                            [filter]="true" (onChange)="onFilterChange()" [emptyMessage]="'NoResultsFound' | localize"
                            [emptyFilterMessage]="'NoResultsFound' | localize">
                        </p-multiSelect>
                    </div>
                </div>

                <div class="input-label-cont extra form-grid-item">
                    <div class="input-cont icon-addon">
                        <p-multiSelect class="input-txt truncate-multiselect" [options]="juridicalPersonOptions"
                            [(ngModel)]="selectedJuridicalPersons" optionLabel="label" optionValue="value"
                            [placeholder]="'JuridicalPersons' | localize" [selectedItemsLabel]="l('SelectedItemsLabel')"
                            [filter]="true" (onChange)="onFilterChange()" [emptyMessage]="'NoResultsFound' | localize"
                            [emptyFilterMessage]="'NoResultsFound' | localize">
                        </p-multiSelect>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-card-body fixed-height-persons">

            <p-table [value]="events" [resizableColumns]="true" [reorderableColumns]="true" [scrollable]="true"
                scrollHeight="flex" [rows]="pageSize" [paginator]="false" [totalRecords]="totalItems" [lazy]="true"
                [loading]="loading" (onLazyLoad)="getDataPage($event)" [rowsPerPageOptions]="[5, 10, 20, 50]"
                [customSort]="true" (sortFunction)="onSort($event)" class="custom-table">

                <!-- Cabecera -->
                <ng-template pTemplate="header">
                    <tr cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="onColumnDrop($event)">
                        <th class="aux-col"></th>
                        <ng-container *ngFor="let col of visibleColumns; let last = last">
                            <th pResizableColumn [pSortableColumn]="col.field" cdkDrag [cdkDragDisabled]="isResizing"
                                [ngClass]="{ 'before-actions-col': last }">
                                {{ col.header | localize }}
                                <i *ngIf="orderField === col.field" class="pi" [ngClass]="{
                            'pi-sort-up': orderDirection === 1,
                            'pi-sort-down': orderDirection === -1
                            }" style="margin-left: 6px; font-size: 0.8rem;"></i>
                            </th>
                        </ng-container>
                        <th class="actions-col">
                            <button #menuAnchor pButton type="button" icon="pi pi-cog" class="gear-btn"
                                (click)="columnOverlay.toggle($event)">
                            </button>
                            <p-overlayPanel #columnOverlay [dismissable]="true" appendTo="body">
                                <div class="column-menu">
                                    <div *ngFor="let col of columns" class="column-toggle-item"
                                        (click)="toggleColumn(col)">
                                        <span class="pi"
                                            [ngClass]="col.visible ? 'pi-check-square' : 'pi-square'"></span>
                                        <label class="ms-2">{{ col.header | localize }}</label>
                                    </div>
                                </div>
                            </p-overlayPanel>
                        </th>
                    </tr>
                </ng-template>

                <!-- Cuerpo -->
                <ng-template pTemplate="body" let-item>
                    <tr>
                        <td></td>
                        <td *ngFor="let col of visibleColumns">
                            <ng-container [ngSwitch]="col.field">
                                <span *ngSwitchCase="'name'">
                                    {{ item.name }}
                                </span>
                                <span *ngSwitchCase="'date'">
                                    {{ item.date | date: (item.date | date: 'HH:mm') === '00:00' ? 'dd/MM/yyyy' :
                                    'dd/MM/yyyy HH:mm' }}
                                </span>
                                <span *ngSwitchCase="'type'">
                                    {{ getEventTypeName(item) }}
                                </span>
                                <span *ngSwitchDefault>
                                    {{ item[col.field] }}
                                </span>
                            </ng-container>
                        </td>
                        <td class="buttons-container center actions-col">
                            <button *ngIf="item.type !== 1" type="button" class="btn-row"
                                [pTooltip]="'CreateReminder' | localize" (click)="createReminder(item)">
                                <i class="material-icons-outlined">add_alert</i>
                            </button>
                            <span *ngIf="item.type === 1" class="btn-row" style="visibility: hidden;">
                                <i class="material-icons-outlined">add_alert</i>
                            </span>
                        </td>
                    </tr>
                </ng-template>

                <!-- Mensaje vacío -->
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td [attr.colspan]="visibleColumns.length + 1" class="text-center">
                            {{ 'NoInfoRecorded' | localize }}
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <div class="table-card-footer paginator-footer">
            <button class="btn-row" (click)="refresh()">
                <i class="material-icons-outlined">refresh</i>
            </button>
            <p class="mb-0 my-2">
                {{ "TotalRecordsCount" | localize : totalItems }}
            </p>
            <p-paginator [rows]="pageSize" [totalRecords]="totalItems" [showFirstLastIcon]="true"
                [first]="(pageNumber - 1) * pageSize" (onPageChange)="getDataPage($event)">
            </p-paginator>
        </div>
    </div>
</div>